<div class="transport-routinglog-inspector">
    <div class="transport-routinglog-inspector-layout" [formGroup]="inputFormGroup">
        <mat-form-field style="grid-row: 1; grid-column: 1 / span 2;" appearance="fill">
          <mat-label>
            <sc-dictionary-label dictionaryKey="tmc-yard.ui.admin.transport-routinglog-inspector.transport-log-key"></sc-dictionary-label>
          </mat-label>
            <input matInput name="transportLogKey" formControlName="transportLogKey">
        </mat-form-field>
        <div style="grid-row: 2; grid-column: 1">
          <sc-dictionary-label dictionaryKey="tmc-yard.entity.routing-log.username"></sc-dictionary-label>
        </div>
        <div style="grid-row: 2; grid-column: 2">
            {{details.username}}
        </div>
        <div style="grid-row: 3; grid-column: 1">
          <sc-dictionary-label dictionaryKey="tmc-yard.entity.routing-log.timestamp"></sc-dictionary-label>
        </div>
        <div style="grid-row: 3; grid-column: 2">
            {{details.timestamp}}
        </div>
        <div style="grid-row: 4; grid-column: 1">
          <sc-dictionary-label dictionaryKey="tmc-yard.entity.routing-log.activity-type"></sc-dictionary-label>
        </div>
        <div style="grid-row: 4; grid-column: 2">
            {{details.activityType}}
        </div>
        <div style="grid-row: 5; grid-column: 1">
          <sc-dictionary-label dictionaryKey="tmc-yard.entity.routing-log.execution-type"></sc-dictionary-label>
        </div>
        <div style="grid-row: 5; grid-column: 2">
            {{details.executionType}}
        </div>
        <div style="grid-row: 6; grid-column: 1">
          <sc-dictionary-label dictionaryKey="tmc-yard.entity.routing-log.note"></sc-dictionary-label>
        </div>
        <div style="grid-row: 6; grid-column: 2">
            {{details.note}}
        </div>
    </div>
</div>
